var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagram = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 50,
  height: 50,
  viewBox: "0 0 50 50"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 24.5,
  stroke: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M31.406 17.155a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.88M25 29a4 4 0 1 1 0-7.999 4 4 0 0 1 0 8m0-10.163a6.162 6.162 0 1 0 0 12.325 6.162 6.162 0 0 0 0-12.325M25 13c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98C13.014 21.333 13 21.742 13 25c0 3.26.014 3.668.072 4.947.2 4.36 2.618 6.781 6.98 6.981 1.281.058 1.69.072 4.948.072 3.26 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.98-6.98.058-1.28.072-1.689.072-4.948s-.014-3.667-.073-4.947c-.195-4.354-2.617-6.78-6.978-6.98C28.67 13.014 28.26 13 25 13m0 2.163c3.204 0 3.584.012 4.85.07 3.251.148 4.771 1.691 4.918 4.92.06 1.264.07 1.644.07 4.848 0 3.205-.012 3.584-.07 4.85-.148 3.223-1.663 4.77-4.919 4.918-1.265.057-1.643.07-4.849.07-3.204 0-3.584-.013-4.849-.07-3.26-.149-4.77-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849s.013-3.583.07-4.849c.15-3.227 1.664-4.77 4.92-4.919 1.265-.057 1.644-.069 4.848-.069"
}))));
export default SvgInstagram;